// This file was automatically generated from app.shared.network.profileDetails.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.shared.network.profileDetails');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.network.profileDetails.mappedContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><form><div class="canonical-overview"></div><div class="canonical-contact-details el8ProfileTop"><div class="el8FieldSection padb10"><label class="el8label el8ProfileLabelText">Specialty</label><div class="el8ProfilePadding mr5"><ol class="canonical-specialties-list"></ol><ol class="local-specialties-list"></ol><textarea type="text" class="w100" name="specialties"></textarea><p class="ml5"><a class="show-custom-field" data-name="specialties">Add a specialty</a>&nbsp;</p></div></div><div class="el8FieldSection padb10"><div class="el8FieldSection"><label class="el8label el8ProfileLabelText">Clinic Name</label><div class="el8ProfilePaddingText"><p class="canonical-ss-clinic-name"></p></div></div></div><div class="padb10"><div class="el8FieldSection"><label class="el8label el8ProfileLabelText">Address</label><div class="el8ProfilePaddingText"><p class="canonical-address"></p><p><a class="show-custom-field" data-name="address">Use a different address</a></p></div></div>');
  el8.template.app.shared.network.profileDetails.addressField({isMapped: true}, output);
  output.append('</div><div class="padb10"><div class="el8FieldSection"><label class="el8label el8ProfileLabelText">Phone</label><div class="el8ProfilePaddingText"><p class="canonical-phone"></p><p><a class="show-custom-field" data-name="phone">Use a different phone</a></p></div></div>');
  el8.template.app.shared.network.profileDetails.phoneField({isMapped: true}, output);
  output.append('</div><div class="padb10"><div class="el8FieldSection"><label class="el8label el8ProfileLabelText">Fax</label><div class="el8ProfilePaddingText"><p class="canonical-fax"></p><p><a class="show-custom-field" data-name="fax">Use a different fax</a></p></div></div>');
  el8.template.app.shared.network.profileDetails.faxField({isMapped: true}, output);
  output.append('</div><div class="padb10"><div class="el8FieldSection"><label class="el8label el8ProfileLabelText">Accepting new pts?</label><div class="el8ProfilePaddingText"><p class="replace-info canonical-new-pts"></p><p><a class="replace-with-custom-field" data-name="acceptingNewPatients">Change</a></p><div class="custom-field" style="display: none">');
  el8.template.app.shared.network.profileDetails.acceptingPatientsInput(null, output);
  output.append('</div></div></div></div><div class="padb10"><div class="el8FieldSection"><label class="el8label el8ProfileLabelText">Accepts insurance?</label><div class="el8ProfilePaddingText"><p class="replace-info canonical-insurance"></p><p><a class="replace-with-custom-field" data-name="acceptingInsurance">Change or Add Insurance</a></p><div class="custom-field" style="display: none">');
  el8.template.app.shared.network.profileDetails.acceptingInsuranceInput(null, output);
  output.append('</div></div></div></div><div class="padb10">');
  el8.template.app.shared.network.profileDetails.insuranceAcceptedField(null, output);
  output.append('</div></div><div class="el8ProfileBottom"><p class="el8ProfileSource padb10">Additional Information (Visible only to my practice)</p>');
  el8.template.app.shared.network.profileDetails.additionalInfoFields(null, output);
  output.append('</div></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.network.profileDetails.unmappedContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><div class="el8UnverifiedProfileSection"></div><form class="profile-display-section"><div class="el8UnverifiedProfileTop"><div class="clearfix relative"><div class="el8ProfilePhotoWrap"><img class="el8ProfilePhoto" src="/static/images/photo_unknown_300.png" style="width: 100px; height: 100px"></img><span class="passport-user-icon el8PassportMark32" style="display: none;"></span></div><div class="el8ProfileInfoWPhotoWrap"><div class="el8FieldSection"><label class="el8label el8FieldShort">Type:</label><div class="el8FieldShortLabelPadding el8Wrap"><input name="contactType" type="radio" class="options" value="physician" checked /><span class="el8StandardFontSize">Individual</span><input name="contactType" type="radio" class="options" value="medical_group" /><span class="el8StandardFontSize">Organization</span></div></div><div class="physician-block"><div class="el8ProfileLeftInput el8TextareaWrap"><input type="text" class="w100 el8HideDisabledInfoText" name="firstName" /></div><div class="el8ProfilePadding el8TextareaWrap"><input type="text" class="w100 el8HideDisabledInfoText" name="middleName" /></div><div class="el8ProfileLeftInput el8TextareaWrap"><input type="text" class="w100 el8HideDisabledInfoText" name="lastName" /></div><div class="el8ProfilePadding el8TextareaWrap"><input type="text" class="w100 el8HideDisabledInfoText" name="credentials" /></div></div><div class="medical-group-block hidden"><div class="el8FieldSection"><div class="ml0 el8TextareaWrap"><input type="text" class="w100" name="name" /></div></div></div><p class="padt5 trigger-section"></p></div></div></div><div class="el8ProfileOverride"><div class="el8FieldSection"><label class="el8label el8ProfileLabel">Specialty</label><div class="el8ProfilePadding mr5"><ol class="specialties-list"></ol><textarea type="text" class="w100 el8HideDisabledInfoText" name="specialties"></textarea></div></div>');
  el8.template.app.shared.network.profileDetails.addressField({isMapped: false}, output);
  el8.template.app.shared.network.profileDetails.phoneField({isMapped: false}, output);
  el8.template.app.shared.network.profileDetails.faxField({isMapped: false}, output);
  output.append('<div class="el8FieldSection padb7"><label class="el8label el8ProfileLabel">Accepting new pts?</label><div class="el8ProfilePadding">');
  el8.template.app.shared.network.profileDetails.acceptingPatientsInput(null, output);
  output.append('</div></div><div class="el8FieldSection padb2"><label class="el8label el8ProfileLabel">Accepts insurance?</label><div class="el8ProfilePadding">');
  el8.template.app.shared.network.profileDetails.acceptingInsuranceInput(null, output);
  output.append('</div></div>');
  el8.template.app.shared.network.profileDetails.insuranceAcceptedField(null, output);
  output.append('</div><div class="el8ProfileBottom"><p class="el8ProfileSource padb10">Additional Information</p>');
  el8.template.app.shared.network.profileDetails.additionalInfoFields(null, output);
  output.append('</div></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.network.profileDetails.unmappedContentHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isUserOwned) ? '<span>Only the profile owner can update their contact information</span>' : '<button class="el8button delete-trigger fr el8ProfileDeleteButton">Delete Profile</button><span>Unverified Profile</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.network.profileDetails.unmappedTriggerSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.connectionId) ? '<a class="connection-write-letter-trigger padr10" data-id="' + soy.$$escapeHtml(opt_data.connectionId) + '">Letter</a><a class="connection-write-referral-trigger padr10" data-id="' + soy.$$escapeHtml(opt_data.connectionId) + '">Referral</a>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.network.profileDetails.addressField = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection"><label class="el8label el8ProfileLabel">', (opt_data.isMapped) ? 'Preferred ' : '', 'Address</label><div class="el8ProfilePadding el8TextareaWrap"><input type="text" class="w100 el8AddressFieldTop" name="address" /><input type="text" class="w50 el8AddressFieldCity" name="city" /><input type="text" class="w15 el8AddressFieldStateZip" name="state" /><input type="text" class="w30 el8AddressFieldStateZip" name="zip" /></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.network.profileDetails.phoneField = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection"><label class="el8label el8ProfileLabel">', (opt_data.isMapped) ? 'Preferred ' : '', 'Phone</label><div class="el8ProfilePadding el8TextareaWrap"><input type="text" class="w100" name="phone" /><a class="el8RemoveButton remove-override-trigger" data-name="phone"></a></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.network.profileDetails.faxField = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection"><label class="el8label el8ProfileLabel">', (opt_data.isMapped) ? 'Preferred ' : '', 'Fax</label><div class="el8ProfilePadding el8TextareaWrap"><input type="text" class="w100" name="fax" /><a class="el8RemoveButton remove-override-trigger" data-name="fax"></a></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.network.profileDetails.acceptingPatientsInput = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<select name="acceptingNewPatients" class="w50"><option value="">Select one</option><option value="1">Yes</option><option value="0">No</option></select>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.network.profileDetails.acceptingInsuranceInput = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<select name="acceptingInsurance" class="w50"><option value="">Select one</option><option value="1">Yes</option><option value="0">No</option></select>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.network.profileDetails.insuranceAcceptedField = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection"><label class="el8label el8ProfileLabel">Insurance(s) accepted:</label><div class="el8ProfilePadding el8TextareaWrap"><textarea class="w100" name="insuranceAccepted"></textarea></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.network.profileDetails.additionalInfoFields = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="local-only-additional-fields"><div class="el8FieldSection"><label class="el8label el8ProfileLabel">Email</label><div class="el8ProfilePadding el8TextareaWrap"><input type="text" class="w100" name="email" /></div></div><div class="el8FieldSection"><label class="el8label el8ProfileLabel">Cell Phone</label><div class="el8ProfilePadding el8TextareaWrap"><input type="text" class="w100" name="cellPhone" /></div></div><div class="el8FieldSection"><label class="el8label el8ProfileLabel">Back Office</label><div class="el8ProfilePadding el8TextareaWrap"><input type="text" class="w100" name="backOfficePhone" /></div></div><div class="el8FieldSection"><label class="el8label el8ProfileLabel">Direct Address</label><div class="el8ProfilePadding el8TextareaWrap"><input type="text" class="w100" name="directAddress" /></div></div></div><div class="el8FieldSection"><label class="el8label el8ProfileLabel">Notes</label><div class="el8ProfilePadding el8TextareaWrap"><textarea class="w100" name="notes"></textarea></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.network.profileDetails.canonicalOverview = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8ProfileSourceSection"><p><span class="el8ProfileSource">Elation Profile</span><span class="fr el8ProfileUpdateText">Profile last updated: ', (opt_data.canonical.lastUpdated) ? (soy.$$escapeHtml(opt_data.canonical.lastUpdated)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.canonical.lastUpdated)) : '') : 'Unknown', '</span></p></div><div class="profile-display-section el8ProfileTop"><div class="clearfix relative"><div class="el8ProfilePhotoWrap">', (opt_data.canonical.isOrg) ? '<img class="el8ProfilePhoto" src="/static/images/avatar_organization.png" style="width: 100px; height: 100px"></img>' : (opt_data.canonical.publicAccessUserId) ? '<img class="el8ProfilePhoto" src="/user/' + soy.$$escapeHtml(opt_data.canonical.publicAccessUserId) + '/photo/profile/100/100/"></img>' : '<img class="el8ProfilePhoto" src="/static/images/avatars/unknown-physician-avatar.png" style="width: 100px; height: 100px"></img>', (opt_data.canonical.providerLogo == 'emr') ? '<span class="el8ElationUserTag">Elation User</span><span class="emr-user-icon el8ElationMark32"></span>' : (opt_data.canonical.providerLogo == 'passport') ? '<span class="passport-user-icon el8PassportMark32"></span>' : '', '</div><div class="el8ProfileInfoWPhotoWrap"><p class="el8ExtraLargeFontSize padt20 el8Bold">', soy.$$escapeHtml(opt_data.canonical.name), (opt_data.canonical.credentials) ? ', ' + soy.$$escapeHtml(opt_data.canonical.credentials) : '', (opt_data.canonical.practicingStatus == 'retired') ? ' (retired)' : '', (opt_data.canonical.lastUpdated) ? '<span class="verified-icon el8VerifiedMark16"></span>' : '', '</p>', (opt_data.canonical.npi) ? '<p class="el8LargeFontSize padt5">NPI ' + soy.$$escapeHtml(opt_data.canonical.npi) + '</p>' : '', '<p class="padt5"><a class="connection-write-letter-trigger padr10" data-id="', soy.$$escapeHtml(opt_data.connectionId), '">Letter</a><a class="connection-write-referral-trigger padr10" data-id="', soy.$$escapeHtml(opt_data.connectionId), '">Referral</a></p></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.network.profileDetails.formattedBoolean = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.bool) ? 'Yes' : (opt_data.bool == undefined || opt_data.bool == null || opt_data.bool == '') ? 'Unknown' : 'No');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.network.profileDetails.canonicalSpecialties = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var sList9889 = opt_data.canonical.specialties;
  var sListLen9889 = sList9889.length;
  for (var sIndex9889 = 0; sIndex9889 < sListLen9889; sIndex9889++) {
    var sData9889 = sList9889[sIndex9889];
    output.append('<li><span class="el8StandardFontSize el8Bold">', soy.$$escapeHtml(sData9889.name), '</span></li>');
  }
  if (!opt_sb) return output.toString();
};
